import { createSlice } from "@reduxjs/toolkit";
import SearchApis from "api/Search/Search"


const initialCoursestate = {
    SUGGESTIONS: "",
}

const slice = createSlice({
    name: "Search",
    initialState: {
        Search: initialCoursestate,
    },
    reducers: {
        getSUGGESTIONS: (state, action) => {
    
            state.Search.SUGGESTIONS = action.payload
          }
    }

})
export default slice.reducer;

const {getSUGGESTIONS} = slice.actions

  export const getSUGGESTIONAction = (payload) => async dispatch => {
    try {

      let response = await SearchApis.SearchSuggestion(payload)
      await dispatch(getSUGGESTIONS(response))

      return await returnCode(response)
    } catch (error) {
       return console.error(error.message)
    }
  }

  function returnCode(response) {
    if (response.ResponseCode == 100 || 200) {
      return response;
    } else if (response.ResponseCode == 103) {
      return 103;
    } else {
      return 101;
    }
  }